import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { ShieldCheck, ShieldAlert } from 'lucide-react';
import api from '../../api/axios';
import styles from './SocietyGates.module.css';

const SocietyGates = () => {
  const [gates, setGates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGates();
  }, []);

  const fetchGates = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/admin/gates');
      setGates(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      toast.error('Failed to load gates');
      setLoading(false);
    }
  };

  const toggleGate = async (id) => {
    try {
      const { data } = await api.put(`/admin/gates/${id}/toggle`);
      setGates(gates.map(g => g._id === id ? data : g));
      toast.success(`${data.name} is now ${data.status}`);
    } catch (err) {
      toast.error('Failed to toggle gate');
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Society Gates Control</h2>
        <p>Manage access to different entry points of the society.</p>
      </div>

      <div className={styles.gatesGrid}>
        {loading ? <p>Loading...</p> : gates.map(gate => (
          <div key={gate._id} className={styles.gateCard}>
            <div className={styles.gateIconWrapper}>
              {gate.status === 'Open' ? (
                <ShieldCheck size={32} color="#166534" />
              ) : (
                <ShieldAlert size={32} color="#991b1b" />
              )}
            </div>
            
            <div className={styles.gateInfo}>
              <h3>{gate.name}</h3>
              <span className={`${styles.statusBadge} ${gate.status === 'Open' ? styles.open : styles.closed}`}>
                {gate.status}
              </span>
            </div>

            <div className={styles.toggleWrapper}>
              <label className={styles.switch}>
                <input 
                  type="checkbox" 
                  checked={gate.status === 'Open'} 
                  onChange={() => toggleGate(gate._id)}
                />
                <span className={styles.slider}></span>
              </label>
              <span className={styles.toggleLabel}>
                {gate.status === 'Open' ? 'Lock Gate' : 'Unlock Gate'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocietyGates;
